import React, {useEffect} from 'react';
// import styled from 'styled-components';

import AnalyticsService from './../../services/AnalyticsService';

import Meta from './../layout/Meta';
import Layout from '../layout/Layout';
import Header from '../layout/Header';
import Section from '../layout/Section';
import Padding from '../layout/Padding';
// import Row from './../../common/components/Row';
// import Col from './../../common/components/Col';
import Typo from './../../common/components/Typo';
import Cta from './../../common/components/Cta';
// import Button from './../../common/components/Button';


const HomePage = ({layout}) => {
  useEffect(() => {
    AnalyticsService.init();  
  }, []);

  return (
    <Layout layout={layout}>
      <Meta
      />
      <Header 
        uppertext={"Riparazioni meccaniche auto e furgoni dal 1999"}
        text={"Autofficina ACS"}
        lowertext={"di Meneghel Mirko e Juri SAS"}
        page="homepage"
        alt="Emotional image"
      />
      
      <Section 
        variant="white" 
      >
        <Padding top right bottom left>
          <Typo type="h2" align="center">Autofficina ACS</Typo>
          <Typo type="p" align="center">
            Benvenuti su Autofficina ACS di Meneghel Mirko e Juri S.a.s.!<br/>
            Dal 1999 ci prendiamo cura della tua auto e del tuo furgone con professionalità ed esperienza.<br/>
            Offriamo servizi di riparazione, manutenzione e diagnostica avanzata per garantirti sicurezza e prestazioni ottimali.<br/>
            Affidati a noi per un servizio attento e di qualità.
          </Typo>   
        </Padding>
      </Section>
      
      <Section 
        variant="lightblue" 
        imageSx={"/web/sections/homepage-servizi.jpg"}
      >
        <Padding top right bottom left>
          <Typo type="h2" align="center">I nostri servizi</Typo>
          <Typo type="p">
            Offriamo riparazioni, manutenzione, servizi di gommista ed elettrauto per ogni esigenza. Scopri tutto ciò che possiamo fare per il tuo veicolo!
          </Typo>  
          <br/>
          <center>
            <Cta 
              size="big"
              variant="light-o"
              text="Servizi"
              link="/servizi"
              icon="arrow_forward"
            />
          </center>        
        </Padding>
      </Section>
      
      <Section 
        variant="darkblue" 
      >
        <Padding top right bottom left>
          <Typo type="h2" align="center">Chi Siamo</Typo>
          <Typo type="p">
            Un'azienda con oltre 20 anni di esperienza nel settore, attrezzature all'avanguardia e un team sempre pronto ad aiutarti.
          </Typo>  
          <br/>
          
          <center>
            <Cta 
              size="big"
              variant="light-o"
              text="Chi Siamo"
              link="/chi-siamo"
              icon="arrow_forward"
            />
          </center>        
        </Padding>
      </Section>
      
      <Section 
        variant="white" 
        imageDx={"/web/sections/homepage-contattaci.jpg"}
      >
        <Padding top right bottom left>
          <Typo type="h2" align="center">Contattaci</Typo>
          <Typo type="p" align="center">
            Per informazioni, preventivi o appuntamenti, non esitare a chiamarci o scriverci!
          </Typo>    
          <br/>
          <center>
            <Cta 
              size="big"
              variant="dark-o"
              text="Contattaci"
              link="/contatti"
              icon="arrow_forward"
            />
          </center>         
        </Padding>
      </Section>
    </Layout>
  )
}

export default HomePage
